import React, { useContext } from 'react'
import { FormContext } from '../FormContext';
import { Col } from "react-bootstrap";
import "./customelements.css"

const Header = ({ label, category, md }) => {
    const { handleChange } = useContext(FormContext)
    const HEADER_MAP = {
        "H1":<h1>{label}</h1>,
        "H2":<h2>{label}</h2>,
        "H3":<h3>{label}</h3>,
        "H4":<h4>{label}</h4>,
        "H5":<h5>{label}</h5>,
        "H6":<h6>{label}</h6>
    }
    return (
        <Col md={md} style={category!=="H6" ? {margin: "15px 0px 5px 0px"}: {margin: "5px 0px 0px 0px"}}>
            {label!==undefined?(category!==undefined || category!==""?HEADER_MAP[category]:HEADER_MAP["H1"]):<></>}
        </Col>
    )
}

export default Header